import "./UserDetailsAddComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import {Field, FieldProps, Formik, FormikProps} from "formik";
import React, {useCallback, useEffect, useRef, useState} from "react";
import Grid from "@mui/material/Grid";
import FormikSelectDropdownComponent
    from "../../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import FeedbackComponent from "../../../../shared/components/feedback/feedbackComponent";
import AccordionComponent from "../../../../shared/components/accordion/accordionComponent";
import {CommonService} from "../../../../shared/services";
import * as Yup from "yup";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import UserDetailsComponent from "../../../../shared/components/user-details/UserDetailsComponent";
import RouteConfigService from "../../../../shared/services/route-config.service";
import {useLocation, useNavigate} from "react-router-dom";
import LinkComponent from "../../../../shared/components/link/LinkComponent";

interface UserDetailsAddComponentProps {
    facilityId: number;
    facilityDetails: any;
    cancel: Function;
    next: Function;
    prev: Function;
}

const facilityPhysicianDetailsValidationSchema = Yup.object({
    userId: Yup.string()
        .nullable(),
});


interface facilityPhysicianDetailsFormSchema {
    userId: string;
}

const facilityInformationInitialValues: facilityPhysicianDetailsFormSchema = {
    userId: "",
}

const UserDetailsAddComponent = (props: UserDetailsAddComponentProps) => {
    const {next, facilityId, cancel, prev, facilityDetails} = props;
    const location = useLocation();
    const navigate = useNavigate();
    const [userList, setUserList] = useState<any>([]);
    const [userListDropdown, setUserListDropdown] = useState<any>([]);
    const formikRef = useRef<FormikProps<any>>(null);

    const onHandleNext = useCallback(() => {
        next(userList);
    }, [next, userList]);

    const getUserListDropdown = useCallback(() => {
        CommonService._facility.getFacilityUserDetails().then((response) => {
            setUserListDropdown(response.data);
        }).catch((error) => {
            console.error("Unable to get facility user", error)
        })
    }, [])

    const handleAddUser = useCallback((userId: string | number, facilityId: string | number) => {
        const payload = {
            facilityId: facilityId,
            userId: userId
        }
        formikRef?.current?.setSubmitting(true);
        CommonService._facility.addFacilityUserDetails(payload).then((response) => {
            const selectedUser = userListDropdown.find((user: any) => user?.id?.toString() === userId?.toString());
            if (selectedUser) {
                setUserList((prev: any) => {
                    return [...prev, selectedUser]
                })
                if (formikRef) {
                    formikRef?.current?.setFieldValue("userId", "");
                    formikRef?.current?.setSubmitting(false);
                }
            }
        }).catch((error) => {
            CommonService._alert.showToast(error.message || "Error while adding user")
        })
    }, [userListDropdown])

    const handleRemoveUser = useCallback((user: any) => {
        const payload = {
            facilityId: facilityId,
            userId: user?.id
        }
        CommonService._facility.removeFacilityAssignedUser(payload).then((response) => {
            const userId = user?.id;
            setUserList((prev: any) => {
                return prev.filter((user: any) => user?.id?.toString() !== userId?.toString());
            })
            getUserListDropdown();
            CommonService._alert.showToast(response.message || "Removed user successfully", "success")
        }).catch((error) => {
            CommonService._alert.showToast(error.message || "Error while removing user", "error")
        })
    }, [facilityId, getUserListDropdown])

    const handleRedirectUserModule = useCallback(() => {
        navigate(RouteConfigService.AddUserRoute() + CommonService.setUrlSearchParams({
            returnUrl: location.pathname + location.search,
            permissionType: "facilityUser",
        }))
    }, [location.pathname, location.search, navigate])

    useEffect(() => {
        setUserList(facilityDetails?.userDetails || []);
    }, [facilityDetails]);


    useEffect(() => {
        getUserListDropdown();
    }, [getUserListDropdown]);

    return (
        <div className={'user-details-add-component screen t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'User Details'}
                handleClick={prev}
                tooltipData={"These details relate to the persons adding for this facility."}
            />
            <div className="t-form t-form-back-navigation">
                <div className={'no-form'}>
                    <div className="t-form-controls-wrapper">
                        <>
                            <Formik
                                validationSchema={facilityPhysicianDetailsValidationSchema}
                                initialValues={facilityInformationInitialValues}
                                validateOnChange={false}
                                validateOnBlur={true}
                                innerRef={formikRef}
                                enableReinitialize={true}
                                validateOnMount={true}
                                onSubmit={() => {
                                }}
                            >
                                {({isSubmitting, values, isValid, setFieldValue, validateForm, resetForm}) => {
                                    // eslint-disable-next-line react-hooks/rules-of-hooks
                                    useEffect(() => {
                                        validateForm();
                                    }, [validateForm, values]);
                                    return (
                                        <>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <Field name={'userId'}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikSelectDropdownComponent
                                                                    label={'User'}
                                                                    options={CommonService.getFilteredUsersDropdownList(userList, userListDropdown)}
                                                                    placeholder={'Select User'}
                                                                    // valueKey={'code'}
                                                                    valueKey={'id'}
                                                                    // required={true}
                                                                    getOptionLabel={(option) => (`${option.firstName} ${option.lastName}`) || ''}
                                                                    formikField={field}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                    <div className="redirect-new-link-wrapper">
                                                        <div>Didn't find user?</div>
                                                        <LinkComponent className={"redirect-link"}
                                                                       onClick={handleRedirectUserModule}>Create
                                                            User</LinkComponent>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <ButtonComponent
                                                        className="mrg-left-20 mrg-top-5"
                                                        disabled={!isValid || isSubmitting || values.userId === ''}
                                                        color={"secondary"}
                                                        variant={"outlined"}
                                                        fullWidth={false}
                                                        size={'large'}
                                                        // isLoading={isGetPhysicianDetailsLoading}
                                                        handleClick={() => {
                                                            // getNpiDetails(values.userId, resetForm)
                                                            facilityId && handleAddUser(values.userId, facilityId)
                                                        }}>
                                                        Assign User
                                                    </ButtonComponent>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )
                                }
                                }
                            </Formik>
                            <div className={'form-sub-title mrg-top-20 mrg-bottom-20'}>Added Users</div>
                            {!userList?.length ?
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <FeedbackComponent>
                                            No user have been added.
                                        </FeedbackComponent>
                                    </Grid>
                                </Grid> :
                                <>
                                    {userList?.map((facilityUser: any, index: any) => {
                                            return (
                                                <div key={index} className="accordion-layout mrg-bottom-20">
                                                    <AccordionComponent
                                                        isExpanded={userList[index]?.isFacilityUserExpand}
                                                        title={`${CommonService.capitalizeFirstLetter(facilityUser.firstName)} ${CommonService.capitalizeFirstLetter(facilityUser.middleName)} ${CommonService.capitalizeFirstLetter(facilityUser.lastName)}`}
                                                        subTitle={`(User ID: ${facilityUser?.id} | ${userList[index]?.roleObj?.title || ""})`}
                                                        actions={
                                                            userList[index]?.roleObj?.title === "Facility Admin" ?
                                                                <></> :
                                                                <ButtonComponent
                                                                    startIcon={<RemoveCircleIcon/>}
                                                                    variant={"outlined"}
                                                                    fullWidth={false}
                                                                    size={'small'}
                                                                    type={'button'}
                                                                    color={"primary"}
                                                                    handleClick={
                                                                        () => {
                                                                            handleRemoveUser(facilityUser)
                                                                        }
                                                                    }
                                                                >
                                                                    Remove
                                                                </ButtonComponent>}
                                                    >
                                                        <div className="facilityUser-details-section">
                                                            <UserDetailsComponent user={facilityUser}/>
                                                        </div>
                                                    </AccordionComponent>
                                                </div>
                                            )
                                        }
                                    )}
                                </>
                            }
                        </>
                    </div>
                    <div className='form-action-section'>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            // disabled={formikRef?.current?.isSubmitting}
                            fullWidth={true}
                            handleClick={cancel}
                        >
                            Close
                        </ButtonComponent>
                        <ButtonComponent
                            color={"primary"}
                            type="button"
                            variant={"contained"}
                            // disabled={formikRef?.current?.isSubmitting}
                            fullWidth={true}
                            handleClick={onHandleNext}
                        >
                            Next
                        </ButtonComponent>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default UserDetailsAddComponent;
